export const colorArray = [
  "#CF8B1E",
  "#30869A",
  "#00B74F",
  "#2961CC",
  "#55A4A5",
  "#FF5733",
  "#c3f372",
  "#FF33A1",
  "#66f4d4",
  "#a599fd",
  "#fcd5d5",
  "#36da0f",
  "#e56ca7",
  "#9a28e7",
  "#094223",
];
